import H from 'highcharts'
//TODO improve handling of highcharts

const formatChange=function(val, decimals){
  return (val> 0 ? '+' : '') + H.numberFormat(val, decimals) + '%'
}

export default {
  yAxis: {
    labels: {
      formatter() {
        return formatChange(this.value, -1)
      }
    }
  },
  plotOptions: {
    series: {
      compare: 'percent'
    }
  },
  tooltip: {
    //TODO Dateformat
    pointFormatter: function () {
      const  {valuePrefix='', valueSuffix='', valueDecimals=2, changeDecimals=2, valueFormat=(value, change)=> `${change} (${value})` } = this.series?.tooltipOptions
      const  value = valuePrefix+H.numberFormat(this.y, valueDecimals)+valueSuffix
      const change = formatChange(this.change, changeDecimals)
      const val = valueFormat.call(this, value, change)
      return `<span style="color:${this.series.color}">\u25CF</span>${this.series.name}: ${val}`
    },
  }
}
